import axios from "axios"

const URL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/`

export const login = async (data, {setUserId, setUserName, setToken, setPermission}) => {
  let username = data.usernameLogin
  let password = data.passwordLogin

  console.log('URL: ', URL);
  
  
    // בדיקה שנתוני ההתחברות אינם ריקים
    if (username && username !== '' && password && password !== '') {
        // נסיון גישה לשרת להתחברות
        try {
            const response = await axios.post(URL + `connection/login`, { username, password })

            // אם השרת אישר את הכניסה, יחזיר טוקן והרשאה
            // צפי חזרת אקסס היא אמת או שקר
            if (response.data.success) {
              localStorage.setItem('token', response.data.token)
              localStorage.setItem('userId', response.data?.id)
              localStorage.setItem('permission', response.data.permission)
              localStorage.setItem('userName', `${response.data.firstName} ${response.data.lastName}`)

              console.log('response: ', response);
              
              setToken(response.data.token)
              setUserId(response.data?.id)
              setUserName(`${response.data.firstName} ${response.data.lastName}`)
              setPermission(response.data.permission)
              return true
            } else {
              setUserId('')

              setUserName('')
              setToken('')
              setPermission('')
              localStorage.setItem('token', '')
              localStorage.setItem('userId', '')
              localStorage.setItem('permission', -1)
              localStorage.setItem('userName', '')

              alert('כניסה נכשלה. אנא נסה שוב.');
            }
            console.log(response);
            
          } catch (error) {
            console.log('error: ', error);
            setToken('')
            setUserId('')
            setUserName('')
            setPermission(-1)
            localStorage.setItem('token', '')
            localStorage.setItem('userId', '')
            localStorage.setItem('permission', -1)
            localStorage.setItem('userName', '')
            alert('שגיאה בבקשה לשרת. אנא נסה שוב מאוחר יותר.');
          }
          return false
    }
}
export const registration = async (data, token) => {
    let username = data.firstName
    let password = data.password
    let email = data.email

    // if (data && data.username && data.username != '' && data.password && data.password != '') {
    if (username && username !== '' && password && password !== '' && email && email !== '') {
        try {
            // אפשר להשתמש ב axios בכדי לשלוח את שם המשתמש והסיסמה לשרת
            const response = await axios.post(`${URL}connection/registration`, { 
                username, password, email, token
             })

             console.log(response);
      
            // אם השרת אישר את הכניסה, נכניס את המשתמש לאזור האישי
            if (response.data.success) {
              // כאן תוכל להשתמש בניווט לדף הרלוונטי
              // token = response.data
              // localStorage.setItem('token', response.data)
              // setToken(response.data)
            } else {
              alert('כניסה נכשלה. אנא נסה שוב.');
            }
          } catch (error) {
            console.error(error);
            alert('שגיאה בבקשה לשרת. אנא נסה שוב מאוחר יותר.');
          }
    }
}
export const logout = async (setUserId, setUserName, token, setToken, setPermission) => {
        // console.log('token old: ',token)

        // נסיון גישה לשרת להתחברות
        try {
            // אפשר להשתמש ב axios בכדי לשלוח את שם המשתמש והסיסמה לשרת
            const response = await axios.post(`${URL}/connection/logout`, { token })

            // אם השרת אישר את הכניסה, ימחק טוקן והרשאה
            // צפי חזרת אקסס היא אמת או שקר
            if (response.data.success) {
              console.log('נותקת בהצלחה')
              setToken('')
              setUserId('')
              setUserName('')
              setPermission(-1)
              localStorage.setItem('token', '')
              localStorage.setItem('userId', '')
              localStorage.setItem('permission', -1)
              localStorage.setItem('userName', '')
            } else {
              alert('כניסה נכשלה. אנא נסה שוב.');
            }
          } catch (error) {
            console.error(error);
            alert('שגיאה בבקשה לשרת. אנא נסה שוב מאוחר יותר.');
          }
}
export const checkToken = async (setUserId, setUserName, token, setToken, setPermission) => {
  if (token && token !== '') {
      axios.post(`${URL}/connection/check_token` , {token
      })
      .then((response) => {
        // console.log(response.data);
          if (response.data.success) {
            if (response.data.timer < 60) {
            // if (response.data.timer < 60 && response.data.timer > 50) {
              alert('בעוד דקה המערכת תתנתק')
              // console.log('בעוד דקה המערכת תתנתק')
            }  
          } else {
            setToken('')
            setUserId('')
            setUserName('')
            setPermission(-1)
            localStorage.setItem('token', '')
            localStorage.setItem('userId', '')
            localStorage.setItem('permission', -1)
            localStorage.setItem('userName', '')
          }
      })
      .catch((err) => {
          console.log(err.response)
      })
  }
}



